import { createFileRoute } from '@tanstack/react-router'
import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { siteConfig } from '@/config/site'

export const Route = createFileRoute('/terms')({
  component: TermsPage,
})

function TermsPage() {
  return (
    <Section surface="0" className="pt-10 pb-16 sm:pt-16 sm:pb-24 md:pt-20 md:pb-28">
      <Container className="max-w-3xl">
        <span className="font-mono text-xs uppercase tracking-widest text-fg-muted mb-3 sm:mb-4 block">
          Legal Terms
        </span>
        <h1 className="text-2xl sm:text-4xl font-bold tracking-tight text-fg mb-6 sm:mb-8">
          Terms of Engagement
        </h1>

        <div className="space-y-4 sm:space-y-6 text-sm text-fg-subtle leading-relaxed">
          <p>
            Last Updated: September 2025
          </p>

          <h2 className="text-lg font-semibold text-fg pt-4">
            1. Scope of Presentation
          </h2>
          <p>
            This website provides corporate information regarding the software engineering, mobile development, and systems consulting services offered by {siteConfig.name}. Content does not constitute a formal binding quotation until a custom Statement of Work (SOW) is executed.
          </p>

          <h2 className="text-lg font-semibold text-fg pt-4">
            2. Intellectual Property
          </h2>
          <p>
            All custom client software delivered by {siteConfig.name} is provided with full intellectual property (IP) transfer to the client upon project settlement as specified in the bilateral contract. Company trademarks, frameworks, and website assets remain the property of {siteConfig.name}.
          </p>

          <h2 className="text-lg font-semibold text-fg pt-4">
            3. Governing Law
          </h2>
          <p>
            Commercial agreements and operations are governed in accordance with the commercial laws of Ethiopia and international best practices.
          </p>
        </div>
      </Container>
    </Section>
  )
}
